import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useOnOverflow } from './hooks';
export const Overflower = ({ ellipsis, ellipsedCallback, textRef, }) => {
    useOnOverflow({ ref: textRef, ellipsedCallback, ellipsis });
    return _jsx(_Fragment, {});
};
